import { CheckCircleIcon } from "@heroicons/react/24/outline"
import { classNames } from "../../style/common"

export type NoPercentProgressProps = {
  progress: number,
  title: string,
  isComplete: boolean,
  className?: string
}

export default function NoPercentProgress(props: NoPercentProgressProps) {
  return (
    <div className={classNames(props.className)}>
      <h4 className="sr-only">Status</h4>
      <p className="text-sm font-medium text-contrast-primary">{props.title}</p>
      <div className="flex gap-2">
        {
          props.isComplete &&
          <CheckCircleIcon className="h-6 w-6 bg-green-600 rounded-xl theme-dark text-contrast-primary" />
        }
        <span>
          {`${(props.progress / 1024).toFixed(0)} KB`}
        </span>
      </div>
    </div>
  )
}
